import { useState } from "react";
import Modal from "react-modal";
import "./index.css";

type MeasurementGuideContent = {
  Habilitado?: string;
  TipoMedida?: string;
  UnidadeMedida?: string;
  Colunas?: string[];
  Grade?: Array<{ Etiqueta: string; Valores: string[] }>;
  Instrucoes?: string;
};

export type MeasurementGuideProductType = {
  id: number;
  pluginspaceId: number;
  productId: string;
  content: MeasurementGuideContent;
  created: string;
  updated: string;
};

type MeasurementGuideModalProps = {
  measurementGuideProduct: MeasurementGuideProductType[];
  imgGuide?: string;
};

export function MeasurementGuideModal({
  measurementGuideProduct,
  imgGuide,
}: MeasurementGuideModalProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const guide =
    measurementGuideProduct?.length > 0 ? measurementGuideProduct[0] : null;
  const hasTable =
    guide?.content?.Habilitado === "1" &&
    (guide.content.Colunas?.length ?? 0) > 0 &&
    (guide.content.Grade?.length ?? 0) > 0;

  if (!imgGuide && !hasTable) return null;

  const {
    TipoMedida,
    UnidadeMedida = "",
    Colunas = [],
    Grade = [],
    Instrucoes,
  } = guide?.content ?? {};

  const typeLabel = TipoMedida === "1" ? "Do corpo" : "Da peça";

  return (
    <>
      <div
        className="product-option measurement-guide-trigger"
        onClick={() => {
          if (!imgGuide && hasTable) {
            setIsModalOpen(true);
          }
        }}
      >
        <div className="hide-item">
          <p>Guia de Medidas</p>
          {!imgGuide && hasTable && (
            <svg
              width="8"
              height="14"
              viewBox="0 0 8 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 1L7 7L1 13"
                stroke="#4B4D50"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
        </div>

        {imgGuide && (
          <div className="measurement-guide-expanded">
            <div className="details-guide">
              <img
                src={imgGuide}
                alt="Guia de medidas"
                style={{ width: "100%", height: "auto", objectFit: "contain" }}
              />
            </div>
            {hasTable && (
              <div
                className="hide-item measurement-guide-table-row"
                onClick={(e) => {
                  e.stopPropagation();
                  setIsModalOpen(true);
                }}
              >
                <p>Ver tabela de medidas</p>
                <svg
                  width="8"
                  height="14"
                  viewBox="0 0 8 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 1L7 7L1 13"
                    stroke="#4B4D50"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            )}
          </div>
        )}
      </div>

      <Modal
        isOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
        className="modal-measurement-guide"
        overlayClassName="overlay-modal"
        ariaHideApp={false}
      >
        <div className="measurement-guide-content">
          <div className="measurement-guide-header">
            <h2 className="measurement-guide-title">Tabela de Medidas</h2>
            <button
              className="measurement-guide-close"
              onClick={() => setIsModalOpen(false)}
              aria-label="Fechar guia de medidas"
            >
              <svg
                width="17"
                height="17"
                viewBox="0 0 17 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0.978551 2.97126L6.957 8.94971L0.978551 14.9282L2.97137 16.921L8.94981 10.9425L14.9283 16.921L16.9211 14.9282L10.9426 8.94971L16.9211 2.97126L14.9283 0.978446L8.94981 6.95689L2.97137 0.978446L0.978551 2.97126Z"
                  fill="#636363"
                />
              </svg>
            </button>
          </div>

          <div className="measurement-guide-table-section">
            {UnidadeMedida && (
              <p className="measurement-guide-unit-note">
                As medidas estão em {UnidadeMedida} e podem variar conforme o
                modelo.
              </p>
            )}
            <div className="measurement-guide-table-wrapper">
              <table className="measurement-guide-table">
                <thead>
                  <tr>
                    <th className="measurement-guide-th-size">Etiqueta</th>
                    {Colunas.map((col, i) => (
                      <th key={i} className="measurement-guide-th">
                        {col}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {Grade.map((row, rowIndex) => (
                    <tr key={rowIndex}>
                      <td className="measurement-guide-td-size">
                        {row.Etiqueta}
                      </td>
                      {Colunas.map((_, colIndex) => (
                        <td key={colIndex} className="measurement-guide-td">
                          {row.Valores?.[colIndex] ?? "-"}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {Instrucoes && (
            <div className="measurement-guide-instructions">
              <h3 className="measurement-guide-section-title">
                Como medir suas peças
              </h3>
              <p className="measurement-guide-instructions-text">
                {Instrucoes}
              </p>
            </div>
          )}
        </div>
      </Modal>
    </>
  );
}
